import { selectLoaderByEntity } from '../ui/ui.selectors';
import { SUBSCRIPTIONS } from './subscriptions.actions';

export const selectSubscriptions = (state) => state.subscriptions;
export const selectSubscriptionsItems = (state) => state.subscriptions.items;
export const selectSubscriptionsPagination = (state) => state.subscriptions.pagination;
export const selectSubscriptionsStatus = (state) => selectLoaderByEntity(state, SUBSCRIPTIONS);
